// Mirror index.js: demo mode (MSW-mocked backend) and local mode
// (cp-local-env + real cp-web-e-api) share the role-picker plumbing, so the
// DemoRoute, RoleBadge, and Tableau-demo bundles load for either.
const isDemoMode =
  process.env.REACT_APP_DEMO_MODE === "true" && process.env.NODE_ENV !== "test"
const isLocalMode =
  process.env.REACT_APP_AUTH_MODE === "local" && process.env.NODE_ENV !== "test"
const useFakeAuth = isDemoMode || isLocalMode

let _tableauComponent = null
let _roleBadge = () => null
let _demoRoute = null

if (useFakeAuth) {
  _tableauComponent = require("./DemoTableauWrapper").default
  _roleBadge = require("./DemoRoleBadge").default
  _demoRoute = require("./DemoRouteConfig").default
}

export const getDemoTableau = (fallback) => _tableauComponent || fallback
export const DemoRoleBadge = _roleBadge
export const DemoRoute = _demoRoute
